'use client';

import React, { useEffect } from 'react';
import { useGaEventContext } from '../../gaevent-context-provider';
import useProductCardsGAEvent from '../../../../hooks/use-product-card-ga-events/use-product-card-ga-events';
import { ProductCardCarouselWrapper } from '../../../product-card/product-card-carousel/product-card-carousel-wrapper';
import { RecentViewCarouselProps } from '../types';
import styles from './../recently-viewed.module.scss';

export const RecentViewCarousel = ({
  children,
  products,
  cartDetails
}: RecentViewCarouselProps) => {
  const { isGAEventEnabled, handleClickGaEvent } = useProductCardsGAEvent({
    products,
    cartDetails,
    listNameId: 'PCC HP Recently Viewed',
    activeTab: 'recentlyViewed'
  });
  const { handleGaEventCapture } = useGaEventContext();

  useEffect(() => {
    if (isGAEventEnabled) {
      handleClickGaEvent();
      handleGaEventCapture('recentlyViewed', false);
    }
  }, [isGAEventEnabled, handleClickGaEvent, handleGaEventCapture]);

  return (
    <React.Fragment>
      <ProductCardCarouselWrapper
        gridClassName={styles['recently-viewed-grid-wrapper']}
      >
        {children}
      </ProductCardCarouselWrapper>
    </React.Fragment>
  );
};
